/**
 * Деньги — один формат на всё приложение (29.09).
 *
 * Раньше портфель и балансы печатали через `toLocaleString(undefined)`: вид
 * зависел от локали браузера («$1 037,09», «6 676,6405»), а терминал и авто
 * показывали «5808.11». Плюс портфель выкидывал знак (Math.abs) и оставлял
 * направление одному цвету — «$15,78» красным читалось как прибыль.
 *
 * Правила: точка как разделитель, без разделителя тысяч (как в терминале),
 * доллары — ровно 2 знака, минус всегда явный и стоит ДО доллара («−$15.78»),
 * у нуля знака нет («$0.00», а не «+$0.00» или «−$0.00»).
 */

/** «−» + WORD JOINER (U+2060): после U+2212 браузер разрешает перенос, и в
 *  узкой ячейке минус оставался строкой выше суммы. */
const MINUS = '\u2212\u2060';

/** Число с фиксированной точностью и явным минусом («−» U+2212, как в терминале).
 *  Значение, которое после округления стало нулём, печатается без знака. */
export function fmtNum(v: number | null | undefined, frac = 2): string {
  const n = Number(v);
  if (v == null || !Number.isFinite(n)) return '—';
  const abs = Math.abs(n).toFixed(frac);
  const isZero = Number(abs) === 0;
  return `${n < 0 && !isZero ? MINUS : ''}${abs}`;
}

/** «$1037.09» / «−$15.78» / «$0.00». `plus` — ставить «+» у положительных
 *  (для колонок P&L, где знак важен); у нуля плюса не бывает. */
export function fmtUsd(v: number | null | undefined, opts: { plus?: boolean; frac?: number } = {}): string {
  const n = Number(v);
  if (v == null || !Number.isFinite(n)) return '—';
  const frac = opts.frac ?? 2;
  const abs = Math.abs(n).toFixed(frac);
  const isZero = Number(abs) === 0;
  const sign = isZero ? '' : n < 0 ? MINUS : opts.plus ? '+\u2060' : '';
  return `${sign}$${abs}`;
}
